import BusinessIcon from "@material-ui/icons/BusinessRounded";
import EventAvailableIcon from "@material-ui/icons/EventAvailableRounded";
import ReplayIcon from "@material-ui/icons/ReplayRounded";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRunRounded";
import FolderIcon from "@material-ui/icons/FolderRounded";
import UsersIcon from "@material-ui/icons/GroupRounded";
import NotificationsIcon from "@material-ui/icons/NotificationsRounded";
import LocalPharmacyIcon from "@material-ui/icons/LocalPharmacyRounded";
import SettingsIcon from "@material-ui/icons/SettingsRounded";
import HomeIcon from "@material-ui/icons/HomeRounded";

export const PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50];

export const dxAIAdminMenu = [
  // {
  //   name: "Users",
  //   path: "/users",
  //   icon: <UsersIcon />,
  // },

  {
    name: "Head Organizations",
    path: "/headorgs",
    icon: <BusinessIcon />,
  },
];

export const superAdminMenu = [
  {
    name: "Clinics",
    path: "/orgs",
    icon: <BusinessIcon />,
  },
  {
    name: "Users",
    path: "/users",
    icon: <UsersIcon />,
  },
];

export const orgAdminMenu = [
  {
    name: "Users",
    path: "/users",
    icon: <UsersIcon />,
  },
  {
    name: "My Clinic",
    path: "/orgs/:id",
    icon: <BusinessIcon />,
  },
  {
    name: "Appointment Insight",
    path: "/appointment/insight",
    icon: <BusinessIcon />,
  },
  {
    name: "Medicines List",
    path: "/medicineInventory",
    icon: <LocalPharmacyIcon />,
  },
  {
    name: "Settings",
    path: "/setting",
    icon: <SettingsIcon />,
  },
];

export const userMenu = [
  {
    name: "New Updates",
    isBadge: true,
    path: "/newUpdates",
    icon: <NotificationsIcon />,
  },
  {
    name: "Cases",
    path: "/cases",
    icon: <FolderIcon />,
  },
  {
    name: "-",
    path: "/patients",
    icon: <DirectionsRunIcon />,
  },
  {
    name: "Appointments",
    path: "/appointments/add",
    icon: <EventAvailableIcon />,
  },
  {
    name: "Follow-Up List",
    path: "/followup",
    icon: <ReplayIcon />,
  },
];

export const userMenuDoctor = [
  {
    name: "Home",
    path: "/home",
    icon: <HomeIcon />,
  },
  {
    name: "New Updates",
    isBadge: true,
    path: "/newUpdates",
    icon: <NotificationsIcon />,
  },
  {
    name: "Cases",
    path: "/cases",
    icon: <FolderIcon />,
  },
  {
    name: "-",
    path: "/patients",
    icon: <DirectionsRunIcon />,
  },
  {
    name: "Appointments",
    path: "/appointments",
    icon: <EventAvailableIcon />,
  },
  {
    name: "Follow-Up List",
    path: "/followup",
    icon: <ReplayIcon />,
  },
];

export const AthleteType = {
  TEAM: "team",
  USER: "user",
};

export const APP_URLS = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgotPassword",

  HOME: "/home",

  ORGANIZATIONS: "/orgs",
  ORGANIZATIONS_DEPTS: "/orgs/departments",
  ORGANIZATIONS_ADD: "/orgs/add",
  ORGANIZATIONS_EDIT: "/orgs/edit",
  ORGANIZATIONS_ADD_ADMIN: "/orgs/addAdmin",
  ORGANIZATIONS_DEPTS_ADD_ADMIN: "/orgs/departments/addAdmin",
  ORGANIZATIONS_ADD_DOCTOR: "/orgs/addDoctor",
  ORGANIZATIONS_DEPTS_ADD_DOCTOR: "/orgs/departments/addDoctor",
  ORGANIZATIONS_SETTING: "/setting",

  HEADORGS: "/headorgs",
  HEADORGS_ADD: "/headorgs/add",
  HEADORGS_EDIT: "/headorgs/edit",

  DEPARTMENTS: "/departments",
  DEPARTMENTS_ADD_DOCTOR: "/departments/addDoctor",

  NEW_UPDATES: "/newUpdates",
  PATIENTS: "/patients",
  CASES: "/cases",
  CASES_ADD: "/cases/addCase",

  APPOINTMENTS: "/appointments",
  APPOINTMENTS_ADD: "/appointments/add",
  USERS: "/users",
};

export const ROLES = {
  ROLE_DXAI_ADMIN: "DxAi Admin",
  ROLE_SUPER_ADMIN: "Super Admin",
  ROLE_SYSTEM_ADMIN: "Admin",
  ROLE_CLINIC_OWNER: "Clinic Owner",
  ROLE_DOCTOR: "Doctor",
  ROLE_ORG_ADMIN: "Org Admin",
  ROLE_RECEPTIONIST: "Receptionist",
  ROLE_PHARMACIST: "Pharmacist",
  ROLE_THERAPIST: "Therapist",
};

export const ORGANIZATION_TYPES = {
  HEALTHCARE_PROVIDER: 1,
  EDUCATIONAL_INSTITUTION: 2,
  NON_HEALTHCARE_BUSINESS_OR_Corporation: 3,
};

// Appointment status values written/read by the app. The backend soft-cancels,
// so CANCELLED rows stay in the list and are rendered as struck-through.
export const APPOINTMENT_STATUS = {
  CONFIRMED: "CONFIRMED",
  CHECKED_IN: "CHECKED_IN",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

// `code` is what gets stored and sent to the API; `label` is what the patient
// sees in the WhatsApp cancellation message. Keep codes stable — they are
// reported on. OTHER requires a note (see CancelAppointmentDialog).
export const APPOINTMENT_CANCELLATION_REASONS = [
  { code: "DOCTOR_UNAVAILABLE", label: "Doctor unavailable" },
  { code: "PATIENT_REQUEST", label: "Cancelled at patient's request" },
  { code: "RESCHEDULING", label: "Being rescheduled to another slot" },
  { code: "PAYMENT_ISSUE", label: "Payment not completed" },
  { code: "CLINIC_CLOSED", label: "Clinic closed / emergency" },
  { code: "OTHER", label: "Other" },
];

export const CANCELLED_BY = {
  RECEPTIONIST: "RECEPTIONIST",
  PATIENT: "PATIENT",
  DOCTOR: "DOCTOR",
};

export const IMAGE_FILE_TYPES = ["jpg", "jpeg", "webp", "png"];

export const playingStatusList = [
  {
    id: 1,
    desc: "Playing",
  },
  {
    id: 0,
    desc: "Not Playing",
  },
];

export const timePeriodList = [
  {
    id: 1,
    description: "past 7 days",
  },
  {
    id: 2,
    description: "past 30 days",
  },
  {
    id: 3,
    description: "past 90 days",
  },
  {
    id: 4,
    description: "past 6 months",
  },
  {
    id: 5,
    description: "Past year",
  },
  {
    id: 6,
    description: "All time",
  },
];

export const filtersList = [
  {
    id: 1,
    desc: "Last Name",
    value: "lastName",
  },
  {
    id: 2,
    desc: "Jersey Number",
    value: "jursyNum",
  },
];

export const FOOD_TYPES = {
  FOOD_TO_EAT: "foodToEat",
  FOOD_TO_AVOID: "foodToAvoid",
};
export const APPOINTMENT_SCHEDULE_TIME_MINUTES = 60;
